import { Subjects } from "src/api/product";
import { create } from "zustand";
const useSearchDialogStore = create((set)=>({
        // 초기 상태
        isOpen: false,
        searchTerm: "",
        selectedSubject: Subjects.EN,
        // 다이얼로그 열기
        open: ()=>{
            set({
                isOpen: true
            });
        },
        // 다이얼로그 닫기
        close: ()=>{
            set({
                isOpen: false
            });
        },
        // 검색어 설정
        setSearchTerm: (term)=>{
            set({
                searchTerm: term
            });
        },
        // 검색어 초기화
        clearSearchTerm: ()=>{
            set({
                searchTerm: ""
            });
        },
        // 과목 설정
        setSubject: (subject)=>{
            set({
                selectedSubject: subject
            });
        }
    }));
export default useSearchDialogStore;
